import React, { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import CreateNewTicketForm from "../components/tickets/CreateNewTicket";

export default function CreateNewTicketPage() {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("New Ticket");
  }, [setTitle]);
  return (
    <>
      <CreateNewTicketForm />
    </>
  );
}
